import { useQuery } from '@tanstack/react-query'
import { companyInfoApi, type CompanyInfo } from '../api/client'

// Company/legal identity, entered once by an admin under /platform-settings
// and read by the footer, the contact page and every legal document. Kept in
// one place so the trade name, address and tax details are never hardcoded
// into page copy.
//
// Long staleTime: this changes roughly never, and every legal page mounts it.
export function useCompanyInfo() {
  return useQuery({
    queryKey: ['company-info'],
    queryFn: companyInfoApi.get,
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    retry: 1,
  })
}

// Convenience: the company block with empty strings for anything unset, so
// callers can render `{c['company.address'] || fallback}` without optional
// chaining everywhere.
export function useCompany(): CompanyInfo {
  const { data } = useCompanyInfo()
  return (
    data?.company ?? {
      'company.legal_name': '',
      'company.trade_name': '',
      'company.address': '',
      'company.city': '',
      'company.phone': '',
      'company.email': '',
      'company.tax_office': '',
      'company.tax_no': '',
      'company.mersis_no': '',
      'company.kep': '',
      'company.website': '',
      'company.legal_email': '',
      'company.hosting_notice': '',
    }
  )
}
